module.exports = __webpack_public_path__ + "bae9ee5ea8b6ff0902a146892fd86f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/info.png
// module id = 754
// module chunks = 0